export const ERROR_HEADING = "Oops, Something's gone wrong.";
export const TRY_AGAIN_CTA = 'Try again';
